// src/core/TasksManager/constants.js

export const LABELS = {
    basic: { title: "Standard", color: "#778899" },
    optional: { title: "Optionnel", color: "#A9A9A9" },
    important: { title: "Important", color: "#e74c3c" },
    urgent: { title: "Urgent", color: "#f39c12" },
};

export const COLUMNS = {
    todo: { title: "À faire", color: "#6c6a6a" },
    inProgress: { title: "En cours", color: "#f3f194" },
    toreview: { title: "À revoir", color: "#82dfec" },
    done: { title: "Terminées", color: "#57cf7d" },
};

// Pour l'historique
export const TASK_ACTIONS = {
    created: "créé",
    updated: "modifié",
    deleted: "supprimé",
    inProgress: "mis en cours",
    toreview: "à revoir",
    done: "terminé",
    archived: "archivé",
};


// Pour les categorie d'evenemtn
export const EVENTSCATEGORIES = {
    formation: "Formations chrétiennes",
    evangelisation: "Évangélisation à venir",
    promotions: "Offres & bons plans",
    annonces: "Annonces Thesustain",
    jeux: "Jeux / Défis chrétiens",
    //pubMag: "PubMag (magazine trimestrielle)"
};

export const NOTE_THEMES0 = [
    { id: "t1", background: "#FDE68A", text: "#78350F" }, // jaune sable
    { id: "t2", background: "#BFDBFE", text: "#1E3A8A" }, // bleu clair
    { id: "t3", background: "#BBF7D0", text: "#064E3B" }, // vert pastel
    { id: "t4", background: "#FECACA", text: "#7F1D1D" }, // rouge doux
    { id: "t5", background: "#E9D5FF", text: "#4B0082" }, // violet
    { id: "t6", background: "#F3F4F6", text: "#111827" }, // gris neutre
    { id: "t7", background: "#FBCFE8", text: "#831843" }, // rose
    { id: "t8", background: "#D9F99D", text: "#365314" }, // vert pomme
    { id: "t9", background: "#A7F3D0", text: "#065F46" }, // turquoise
    { id: "t10", background: "#FDE2E2", text: "#7C2D12" }, // saumon
    { id: "t11", background: "#E0E7FF", text: "#3730A3" }, // indigo
    { id: "t12", background: "#FFEDD5", text: "#7C2D12" }, // orange doux
    { id: "t13", background: "#F1F5F9", text: "#0F172A" }, // ardoise
    { id: "t14", background: "#DCFCE7", text: "#14532D" }, // vert clair
    { id: "t15", background: "#FFE4E6", text: "#9F1239" }, // rose poudré
    { id: "t16", background: "#D1FAE5", text: "#065F46" }, // jade
    { id: "t17", background: "#FEF3C7", text: "#92400E" }, // or
    { id: "t18", background: "#E0F2FE", text: "#0369A1" }, // bleu océan
    { id: "t19", background: "#FCE7F3", text: "#9D174D" }, // magenta
    { id: "t20", background: "#F5F5F5", text: "#262626" }, // minimal

    // 👉 Thèmes ajoutés :
    { id: "t21", background: "#FFFFFF", text: "#000000" }, // noir sur blanc
    { id: "t22", background: "#000000", text: "#FFFFFF" }, // blanc sur noir
];
export const NOTE_THEMES = [
    { id: "t1", background: "#FDE68A", text: "#78350F", textSecondary: "#A16207", label: "Jaune sable" },
    { id: "t2", background: "#BFDBFE", text: "#1E3A8A", textSecondary: "#3B82F6", label: "Bleu clair" },
    { id: "t3", background: "#BBF7D0", text: "#064E3B", textSecondary: "#10B981", label: "Vert pastel" },
    { id: "t4", background: "#FECACA", text: "#7F1D1D", textSecondary: "#EF4444", label: "Rouge doux" },
    { id: "t5", background: "#E9D5FF", text: "#4B0082", textSecondary: "#8B5CF6", label: "Violet" },
    { id: "t6", background: "#F3F4F6", text: "#111827", textSecondary: "#6B7280", label: "Gris neutre" },
    { id: "t7", background: "#FBCFE8", text: "#831843", textSecondary: "#EC4899", label: "Rose" },
    { id: "t8", background: "#D9F99D", text: "#365314", textSecondary: "#84CC16", label: "Vert pomme" },
    { id: "t9", background: "#A7F3D0", text: "#065F46", textSecondary: "#14B8A6", label: "Turquoise" },
    { id: "t10", background: "#FDE2E2", text: "#7C2D12", textSecondary: "#F97316", label: "Saumon" },
    { id: "t11", background: "#E0E7FF", text: "#3730A3", textSecondary: "#6366F1", label: "Indigo" },
    { id: "t12", background: "#FFEDD5", text: "#7C2D12", textSecondary: "#F97316", label: "Orange doux" },
    { id: "t13", background: "#F1F5F9", text: "#0F172A", textSecondary: "#64748B", label: "Ardoise" },
    { id: "t14", background: "#DCFCE7", text: "#14532D", textSecondary: "#22C55E", label: "Vert clair" },
    { id: "t15", background: "#FFE4E6", text: "#9F1239", textSecondary: "#F43F5E", label: "Rose poudré" },
    { id: "t16", background: "#D1FAE5", text: "#065F46", textSecondary: "#34D399", label: "Jade" },
    { id: "t17", background: "#FEF3C7", text: "#92400E", textSecondary: "#F59E0B", label: "Or" },
    { id: "t18", background: "#E0F2FE", text: "#0369A1", textSecondary: "#3B82F6", label: "Bleu océan" },
    { id: "t19", background: "#FCE7F3", text: "#9D174D", textSecondary: "#EC4899", label: "Magenta" },
    { id: "t20", background: "#F5F5F5", text: "#262626", textSecondary: "#6B7280", label: "Minimal" },

    // Thèmes simples
    { id: "t21", background: "#FFFFFF", text: "#000000", textSecondary: "#555555", label: "Claire" },
    { id: "t22", background: "#000000", text: "#FFFFFF", textSecondary: "#AAAAAA", label: "Sombre" },
];
